module.exports = "module.exports = require('bender-webpack-config')({\n  directory: __dirname,\n\n  entry: {\n    'main.js': './main.js',\n  },\n\n  rawChunks: {\n    'index.html': './index.html.jade',\n    'style.css': './style.css',\n  },\n});\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/code/webpackConfig.js
// module id = 413
// module chunks = 0